var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46719 13.6217V0.700033C4.46719 0.313435 4.78059 3.43323e-05 5.16719 3.43323e-05C5.55379 3.43323e-05 5.86719 0.313435 5.86719 0.700034V15.277C5.86719 15.3909 5.83995 15.4985 5.79163 15.5936C5.75798 15.6666 5.71109 15.735 5.65097 15.7951C5.37784 16.0683 4.93502 16.0683 4.66189 15.7951L0.33593 11.468C0.0628037 11.1948 0.0628037 10.7519 0.33593 10.4787C0.609057 10.2055 1.05188 10.2055 1.32501 10.4787L4.46719 13.6217Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5309 2.37832V15.3C11.5309 15.6866 11.2175 16 10.8309 16C10.4443 16 10.1309 15.6866 10.1309 15.3V0.723036C10.1309 0.609066 10.1581 0.501459 10.2064 0.406366C10.2401 0.333399 10.287 0.265036 10.3471 0.204898C10.6202 -0.0682994 11.063 -0.0682994 11.3362 0.204898L15.6621 4.53198C15.9352 4.80518 15.9352 5.24812 15.6621 5.52132C15.389 5.79452 14.9462 5.79452 14.673 5.52132L11.5309 2.37832Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort_icon.e652a5fe39f845e89e175b0cdb0502ff.svg";
export { ForwardRef as ReactComponent };